import React, { MouseEventHandler, ReactNode } from 'react'

import { Radio as AntRadio } from 'antd'

interface RadioButtonProps {
  value?: any
  children: ReactNode
  className?: string
  onClick?: () => void
}

const Radio = (props: RadioButtonProps) => {
  return <AntRadio.Button {...props}>{props.children}</AntRadio.Button>
}

export default Radio
